import { Header } from "../../shared/Style/Style";
import { TrainerWrapper } from "../components/TrainerWrapper";

export const TrainerEdit = () => (
  <TrainerWrapper>
    <Header>Редагування тренажера</Header>
  </TrainerWrapper>
);
